import React from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import './DownloadButton.css';  // Import the custom CSS for the button

const DownloadButton = ({ onClick, children }) => {
  return (
    <button className="download-btn" onClick={onClick}>
      <DownloadOutlined className="download-icon" />
      {children}
    </button>
  );
};

export default DownloadButton;
